import { BasicInfoState } from "app/pages/DiscountEditor/modules/BasicInfo/state";
import { BasicDiscountDetailsDto } from "app/shared/model/DiscountDto";
import { DiscountType } from "app/shared/model/DiscountType";

function getRoot(state: any) : BasicInfoState {
    return state.basicInfo;
}

export function getPublicName(state: any) {
    const root = getRoot(state);
    return root.publicName; 
}

export function getInternalName(state: any) {
    const root = getRoot(state);
    return root.internalName; 
}

export function getDescription(state: any) {
    const root = getRoot(state);
    return root.description; 
}

export function getDiscountType(state: any) {
    const root = getRoot(state);
    return root.discountType;
}

export function getPromotionCode(state: any) {
    const root = getRoot(state);
    return root.promotionCode;
}

export function getBasicDetailsDto(state: any) : BasicDiscountDetailsDto {
    const root = getRoot(state);
    const PromotionCode =
        root.discountType === DiscountType.specialOffer
            ? (() => {
                const t = root.promotionCode.trim();
                return t === '' ? null : t.toUpperCase();
            })()
            : null;
    return {
        publicName: root.publicName,
        internalName: root.internalName,
        description: root.description,
        discountType: root.discountType,
        PromotionCode
    }
}